import { render, staticRenderFns } from "./class-forward.vue?vue&type=template&id=4623aca1&scoped=true&"
import script from "./class-forward.vue?vue&type=script&lang=js&"
export * from "./class-forward.vue?vue&type=script&lang=js&"
import style0 from "./class-forward.vue?vue&type=style&index=0&id=4623aca1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623aca1",
  null
  
)

export default component.exports